import React from "react";
import classNames from "classnames";

class FormErrors extends React.PureComponent {
  render() {
    const { className, errors, ...rest } = this.props;
    const errorsClasses = classNames(
      "form__errors",
      className
    );

    return errors.length > 0 ? (
      <div className={ errorsClasses } { ...rest }>
        { errors.map((error, i) => <span className="form__error" key={ i }>{ error }</span>) }
      </div>
    ) : null;
  }
}

export default FormErrors;


// WEBPACK FOOTER //
// ./app/components/Form/FormErrors.jsx